import { render } from "./BlFormFieldValidationselectorDialog.vue?vue&type=template&id=422e5582&scoped=true"
import script from "./BlFormFieldValidationselectorDialog.vue?vue&type=script&lang=js"
export * from "./BlFormFieldValidationselectorDialog.vue?vue&type=script&lang=js"

import "./BlFormFieldValidationselectorDialog.vue?vue&type=style&index=0&id=422e5582&scoped=true&lang=scss"

import exportComponent from "/tmp/bc49b04f-2ffc-492f-a3c6-ed004d6cdf93/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422e5582"]])

export default __exports__